// import moment from "moment/moment";
import { POST, PUT, SUCCESS, FAILURE } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function obtenerPermisos(obj) {
    try {
        let data = { error: true };
        let { code, body, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/permisos-sub-tipo-usuario-web/obtener-permisos",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.data = body;
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("obtenerPermisos err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function crearPermisos(obj) {
    try {
        let creado = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/permisos-sub-tipo-usuario-web/guardar-permisos",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            creado = true;
        }
        return creado;
    } catch (err) {
        console.log("crearPermisos err");
        console.log(err);
        return false;
    }
}

export async function modificarPermisos(obj) {
    try {
        let modificado = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/permisos-sub-tipo-usuario-web/modificar-permisos",
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            modificado = true;
        }
        return modificado;
    } catch (err) {
        console.log("modificarPermisos err");
        console.log(err);
        return false;
    }
}
